module.exports = __webpack_public_path__ + "img/Chongqing-speed.a35fcb8a.png";